(function() {
  var locale = Shopify && Shopify.locale;
  if (!locale || locale === 'en') return; 
  
  var pathLocale = window.location.pathname.split('/')[1];
  if (!pathLocale || pathLocale.length !== 2) return; 
  
  var prefix = '/' + pathLocale;
  var internals = ['/products/', '/pages/', '/collections/'];

  document.addEventListener('click', function(e) {
    var el = e.target.closest('[data-href]');
    if (!el) return;
    var href = el.getAttribute('data-href');
    if (!href) return;
    var isInternal = internals.some(function(p) { return href.startsWith(p); });
    if (isInternal && !href.startsWith(prefix)) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = prefix + href;
    }
  }, true);
})();